import React from "react";
import PropTypes from "prop-types";

import { styled } from "@mui/system";
import getStyled from "../../hooks/getStyled";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import CardHeader from "@mui/material/CardHeader";
import CardActions from "@mui/material/CardActions";

const { theme } = getStyled();

const CardStyled = styled(Card, {
  name: "CardStyled",
  slot: "Wrapper",
})({
  border: `1px solid ${theme.palette.grey225.main}`,
  borderRadius: "4px",
  boxShadow: "none",
  width: "100%",
});

const CardContentStyled = styled(CardContent, {
  name: "CardContentStyled",
  slot: "Wrapper",
})({
  padding: "16px 20px",
  width: "100%",
});

const CardMediaStyled = styled(CardMedia, {
  name: "CardMediaStyled",
  slot: "Wrapper",
})({});

const CardActionsStyled = styled(CardActions, {
  name: "CardActionsStyled",
  slot: "Wrapper",
})({});

const CardHeaderStyled = styled(CardHeader, {
  name: "CardHeaderStyled",
  slot: "Wrapper",
})({
  alignItems: "center",
});

export const SFCardBody = (props) => {
  return <CardContentStyled {...props}>{props.children}</CardContentStyled>;
};

SFCardBody.propTypes = {
  children: PropTypes.node,
};

export const SFCardImage = (props) => {
  return <CardMediaStyled {...props}>{props.children}</CardMediaStyled>;
};

SFCardImage.propTypes = {
  children: PropTypes.node,
};

export const SFCardHeader = (props) => {
  const { subTitle, ...other } = props;
  return <CardHeaderStyled subheader={subTitle} {...other}></CardHeaderStyled>;
};

SFCardHeader.propTypes = {
  children: PropTypes.node,
};

export const SFCardFooter = (props) => {
  return <CardActionsStyled {...props}>{props.children}</CardActionsStyled>;
};

SFCardFooter.propTypes = {
  children: PropTypes.node,
};

const SFCard = (props) => <CardStyled {...props}>{props.children}</CardStyled>;

SFCard.propTypes = {
  children: PropTypes.node,
};

export default SFCard;
